const state = {
  flashcardStatuses: [],
  flashcardStatusFilterId: null,
};

const getters = {
  flashcardStatuses: state => state.flashcardStatuses.sort((a, b) => a.order - b.order),
  flashcardStatusFilter: (state, getters) => {
    const status = state.flashcardStatuses.find(fs => fs.id === state.flashcardStatusFilterId);
    return status || getters.unansweredFlashcardStatus;
  },
  greenFlashcardStatus: state => state.flashcardStatuses.find(fs => fs.name === 'green'),
  redFlashcardStatus: state => state.flashcardStatuses.find(fs => fs.name === 'red'),
  unansweredFlashcardStatus: state => state.flashcardStatuses.find(fs => fs.name === 'unanswered'),
  yellowFlashcardStatus: state => state.flashcardStatuses.find(fs => fs.name === 'yellow'),
  bookmarkedFlashcardStatus: state => state.flashcardStatuses.find(fs => fs.name === 'bookmarked'),
  answeredFlashcardStatuses: (state, getters) => getters.flashcardStatuses.filter(fs => !['unanswered', 'bookmarked'].includes(fs.name)),
};

const mutations = {
  setFlashcardStatuses(state, statuses) {
    statuses.push({name: 'bookmarked', displayName: 'Saved', id: (Math.max(...statuses.map(s => s.id)) + 1)});
    state.flashcardStatuses = statuses;
  },
  setFlashcardStatusFilter(state, id = null) {
    state.flashcardStatusFilterId = id;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
};
